import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import onboardingSlice from './slices/onboardingSlice';
import uiSlice from './slices/uiSlice';
import creditsSlice from './slices/creditsSlice';
import candidateStatusSlice from './slices/candidateStatusSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    onboarding: onboardingSlice,
    ui: uiSlice,
    credits: creditsSlice,
    candidateStatus: candidateStatusSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

if (typeof window !== 'undefined') {
  (window as any).store = store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;